"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _FacilitiesBlock = _interopRequireDefault(require("../FacilitiesBlock"));
var Facilities = function Facilities(_ref) {
  var attractions = _ref.attractions,
    kids = _ref.kids,
    room = _ref.room,
    territory = _ref.territory,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$attractionsTitle = _ref.attractionsTitle,
    attractionsTitle = _ref$attractionsTitle === void 0 ? _localization.i18n.t('hotel.facilities.attractions') : _ref$attractionsTitle,
    _ref$kidsTitle = _ref.kidsTitle,
    kidsTitle = _ref$kidsTitle === void 0 ? _localization.i18n.t('hotel.facilities.kids') : _ref$kidsTitle,
    _ref$territoryTitle = _ref.territoryTitle,
    territoryTitle = _ref$territoryTitle === void 0 ? _localization.i18n.t('hotel.facilities.territory') : _ref$territoryTitle,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$showBestItemBack = _ref.showBestItemBackground,
    showBestItemBackground = _ref$showBestItemBack === void 0 ? true : _ref$showBestItemBack,
    _ref$showItemBackgrou = _ref.showItemBackground,
    showItemBackground = _ref$showItemBackgrou === void 0 ? true : _ref$showItemBackgrou,
    _ref$inColumns = _ref.inColumns,
    inColumns = _ref$inColumns === void 0 ? false : _ref$inColumns;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
    className: className
  }, room && /*#__PURE__*/_react["default"].createElement(_FacilitiesBlock["default"], {
    isMobile: isMobile,
    title: t('hotel.facilities.hasRooms'),
    items: room,
    showBestItemBackground: showBestItemBackground,
    showItemBackground: showItemBackground,
    inColumns: inColumns
  }), attractions && /*#__PURE__*/_react["default"].createElement(_FacilitiesBlock["default"], {
    isMobile: isMobile,
    title: attractionsTitle,
    items: attractions,
    showBestItemBackground: showBestItemBackground,
    showItemBackground: showItemBackground,
    inColumns: inColumns
  }), territory && /*#__PURE__*/_react["default"].createElement(_FacilitiesBlock["default"], {
    isMobile: isMobile,
    title: territoryTitle,
    items: territory,
    showBestItemBackground: showBestItemBackground,
    showItemBackground: showItemBackground,
    inColumns: inColumns
  }), kids && /*#__PURE__*/_react["default"].createElement(_FacilitiesBlock["default"], {
    isMobile: isMobile,
    title: kidsTitle,
    items: kids,
    showBestItemBackground: showBestItemBackground,
    showItemBackground: showItemBackground,
    inColumns: inColumns
  }));
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Facilities__StyledWrapper",
  componentId: "sc-s0gxmf-0"
})(["padding-top:10px;display:flex;flex-direction:column;gap:11px;padding:11px 6px;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Facilities);